import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WidgetCard from "./WidgetCard";
import { IPriceAndDealsCompetitionWidgetData } from "@ts/common-types";
import { COLORS } from "@ts/constants";
import { includes } from "underscore";

enum ChartType {
    Price = "Price",
    Deals = "% Deals",
    CategoryAveragePrice = "Category Average Price",
}

const PriceAndDealsCompetitionWidget: React.FC<
    IPriceAndDealsCompetitionWidgetData
> = ({ title, widgetData, currencySymbol }) => {
    const chartOptions = {
        chart: {
            type: "column",
        },
        title: {
            text: title || "Price and %Deals",
            style: {
                fontWeight: "normal",
            },
        },
        colors: COLORS,
        credits: {
            enabled: false,
        },
        exporting: {
            enabled: false,
        },
        xAxis: {
            categories: widgetData.products,
            title: {
                text: "Products",
                style: {
                    fontWeight: "normal",
                },
            },
        },
        yAxis: [
            {
                title: {
                    text: `Price (${currencySymbol})`,
                    style: {
                        fontWeight: "normal",
                    },
                },
            },
            {
                title: {
                    text: "% Deals",
                    style: {
                        fontWeight: "normal",
                    },
                },
                opposite: true,
                labels: {
                    formatter: function (this: any) {
                        return this.value + "%";
                    },
                },
            },
        ],
        tooltip: {
            formatter: function (this: any) {
                const skuTitle = widgetData.skuTitles[this.point.index];
                const priceSeries = [ChartType.Price, ChartType.CategoryAveragePrice];
                const isPriceData = includes(priceSeries, this.series.name);
                const units = isPriceData ? currencySymbol : "%";
                return `
                    <b>Product Name:</b> ${skuTitle || "N/A"}
                    <br><br>
                    <b>${this.series.name}:</b> ${
                    isPriceData
                        ? `${units} ${this.y.toFixed(2)}`
                        : `${this.y} ${units}`
                }
                `;
            },
            useHTML: true,
        },
        series: [
            {
                name: ChartType.Price,
                type: "column",
                data: widgetData.prices,
            },
            {
                name: ChartType.Deals,
                type: "line",
                data: widgetData.dealPercentages,
                yAxis: 1,
                color: "#00C852",
                marker: {
                    enabled: true,
                },
                dashStyle: "ShortDash",
            },
            {
                name: ChartType.CategoryAveragePrice,
                type: "line",
                data: widgetData.categoryAveragePrice,
                yAxis: 0,
                color: "rgb(255,0,0)",
                marker: {
                    enabled: true,
                },
            },
        ],
    };

    return (
        <WidgetCard
            overwriteDefaultClass={true}
            className="bg-transparent border-0 rounded-0 shadow-none"
        >
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </WidgetCard>
    );
};

export default PriceAndDealsCompetitionWidget;